export default {
  sort: {
    id: 'landing_page_sort',
    defaultMessage: 'Sort',
  },
}
